import React, { useRef } from 'react';
import {
  motion,
  useAnimationFrame,
  useMotionValue,
  useReducedMotion,
  useScroll,
  useSpring,
  useTransform,
  useVelocity,
} from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './Marquee.css';

const wrap = (min, max, v) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};

// Běžící pás se službami. Rychlost a směr reagují na rychlost scrollování.
const Marquee = ({ baseVelocity = -3 }) => {
  const { t } = useTranslation();
  const reduce = useReducedMotion();
  const items = ['lathe', 'milling', 'grinding', 'control'].map((k) => t(`services.${k}.name`));

  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const velocity = useSpring(useVelocity(scrollY), { damping: 50, stiffness: 400 });
  const factor = useTransform(velocity, [0, 1000], [0, 4], { clamp: false });
  const x = useTransform(baseX, (v) => `${wrap(-50, 0, v)}%`);
  const direction = useRef(1);

  useAnimationFrame((_, delta) => {
    if (reduce) return;
    let move = direction.current * baseVelocity * (delta / 1000);
    if (factor.get() < 0) direction.current = -1;
    else if (factor.get() > 0) direction.current = 1;
    move += direction.current * move * factor.get();
    baseX.set(baseX.get() + move);
  });

  // Dvě stejné poloviny -> plynulá smyčka při posunu o -50 %.
  const half = [...items, ...items, ...items];

  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__band">
        <motion.div className="marquee__track" style={{ x }}>
          {[...half, ...half].map((label, i) => (
            <span className="marquee__item" key={i}>
              {label}
              <svg viewBox="0 0 24 24" className="marquee__star">
                <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
              </svg>
            </span>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Marquee;
